// ABOUTME: Utility for managing the user alias across localStorage and cookies.
// ABOUTME: Ensures the alias is available both client-side and server-side (via cookie) for Remix SSR.

export const COOKIE_NAME = 'user-alias';
const LOCAL_STORAGE_KEY = 'user-alias';

/**
 * Sets the user alias in both localStorage and a cookie.
 * The cookie ensures the alias is available in server-side contexts (e.g. Remix SSR).
 */
export function setUserAlias(alias: string): void {
  if (typeof window === 'undefined') return;

  localStorage.setItem(LOCAL_STORAGE_KEY, alias);
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(alias)}; path=/`;
}

/**
 * Removes the user alias from both localStorage and the cookie.
 */
export function removeUserAlias(): void {
  if (typeof window === 'undefined') return;

  localStorage.removeItem(LOCAL_STORAGE_KEY);
  document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

/**
 * Gets the user alias from localStorage.
 * If the alias exists in localStorage but the cookie is missing, syncs the cookie
 * so that server-side contexts (e.g. Remix SSR) can access it.
 * Returns null if no alias is set.
 */
export function getUserAlias(): string | null {
  if (typeof window === 'undefined') return null;

  const alias = localStorage.getItem(LOCAL_STORAGE_KEY);

  // Sync cookie if localStorage has a value but the cookie is missing
  if (alias && !document.cookie.split('; ').some(c => c.startsWith(`${COOKIE_NAME}=`))) {
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(alias)}; path=/`;
  }

  return alias;
}
